// src/contexts/LoadingContext.jsx
import React, {
  createContext,
  useState,
  useContext,
  useMemo,
  useCallback,
} from "react";

const LoadingContext = createContext({
  isApiLoading: false,
  showApiLoading: () => {},
  hideApiLoading: () => {},
});

export const useApiLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [activeRequests, setActiveRequests] = useState(0);

  const showApiLoading = useCallback(() => {
    setActiveRequests((prev) => {
      if (prev === 0) setIsApiLoading(true);
      return prev + 1;
    });
  }, []);

  const hideApiLoading = useCallback(() => {
    setActiveRequests((prev) => {
      const newCount = Math.max(0, prev - 1);
      if (newCount === 0) setIsApiLoading(false);
      return newCount;
    });
  }, []);

  const value = useMemo(
    () => ({
      isApiLoading,
      _showApiLoadingInternal: showApiLoading,
      _hideApiLoadingInternal: hideApiLoading,
    }),
    [isApiLoading, showApiLoading, hideApiLoading]
  );

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
};
